import React, {Component} from 'react';
import {Button, Header, Message} from 'semantic-ui-react';
import Loader from "../universal/loader";
import ReactTable from "react-table";
import ListingContainer from "../../containers/listing_container";
import {BASE_URL} from "../../constants/app_routes";
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";

class ReportList extends Component {

    constructor(props){
        super(props);
        this.state = {
            isDownloading:false
        }
    }

    handleDownload = async (id,filename) => {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/report/download/"+id;
        await handleFileDownload(URL,filename);
        this.setState({isDownloading:false});
    };

    render() {
        const columns = [{
            Header: 'Report Id',
            accessor: 'id',
            className: 'num-width',
            headerClassName: 'num-width',
            filterable: true
        }, {
            Header: 'Inspection Id',
            accessor: 'inspection_id',
            className: 'num-width',
            headerClassName: 'num-width',
            filterable: true
        }, {
            Header: 'Job type',
            accessor: 'inspection_type',
            id: 'inspection_type',
            className: 'formatcase mini-width',
            headerClassName: 'mini-width dropdown-overlay',
            filterable: true,
            filterMethod: (filter, row) => {
                if (filter.value === "ci") {
                    return row[filter.id] === 'ci';
                }
                if (filter.value === "co") {
                    return row[filter.id] === 'co';
                }
                if (filter.value === "inv") {
                    return row[filter.id] === 'inv';
                }
                if (filter.value === "inv/ci") {
                    return row[filter.id] === 'inv/ci';
                }
                return true;
            },
            Filter: ({filter, onChange}) =>
                <select
                    onChange={event => onChange(event.target.value)}
                    style={{width: "100%"}}
                    value={filter ? filter.value : "all"}
                >
                    <option value="true">Show all</option>
                    <option value="ci">CI</option>
                    <option value="co">CO</option>
                    <option value="inv">INV</option>
                    <option value="inv/ci">INV/CI</option>
                </select>
        }, {
            Header: 'Size',
            accessor: 'property_size',
            className: 'num-width',
            headerClassName: 'num-width',
            filterable: true,
            Cell: ({value}) => (
                <span>{value ? value : "NA"}</span>
            )
        }, {
            Header: 'Property Address',
            accessor: 'property_address',
            className: 'address-width left-aligned',
            headerClassName: 'address-width left-aligned',
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            sortable:false,
            Cell: ({original,value}) => (
                <div>
                    <Button fluid icon primary size='mini' onClick={(e) => this.handleDownload(value,original['filename'])}>View</Button>
                </div>
            )
        }];

        return (<div className="short-listing-container pad-top center-aligned">
                <Header content="Reports" size='large' textAlign='left'/>
                {this.props.errorMessage && <Message color="red">{this.props.errorMessage}</Message>}
                <div>
                    {this.props.isFetching && <Loader/>}
                    {!this.props.isFetching && this.props.data.length > 0 && <ReactTable
                        data={this.props.data}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={10}
                        minRows={0}
                        noDataText="No reports found"
                    />}
                    {!this.props.isFetching && !(this.props.data.length > 0) &&
                    <div className='center'>No Available Reports.</div>}
                </div>
                {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
            </div>
        );
    }
}

export default ListingContainer(ReportList);



// WEBPACK FOOTER //
// ./src/views/report/index.js